import React, { memo, useState, useEffect } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { makeSelectFilterMenuStatus, makeSelectEventTypeFilterDataArray } from '../selectors';
import { toggleEventTypeFilterMenu } from './actions';
import ParentElement from '../../../components/FilterElement/ParentElement';
import { useInjectReducer } from '../../../utils/injectReducer';
import reducer from './reducer';
import { EVENT_TYPE_FILTER_LABEL } from '../../../utils/site';

const key = 'eventType';

export const FilterCollapse = ({
  eventTypeFilterDataArray,
  onToggleEventTypeFilterMenu,
  eventTypeFilterMenuStatus,
}) => {
  useInjectReducer({ key, reducer });
  const [bubbleString, setBubbleString] = useState('');

  useEffect(() => {
    let newBubbleString = '';
    if (eventTypeFilterDataArray.length > 0) {
      newBubbleString = eventTypeFilterDataArray[0];
    }
    if (bubbleString !== newBubbleString) {
      setBubbleString(newBubbleString);
    }
  }, [eventTypeFilterDataArray]);

  /**
   * Main return function.
   */
  return (
    <div onClick={() => onToggleEventTypeFilterMenu(eventTypeFilterMenuStatus)}>
      <ParentElement title={EVENT_TYPE_FILTER_LABEL} bubble={bubbleString} status={eventTypeFilterMenuStatus} />
    </div>
  );
};

FilterCollapse.propTypes = {
  eventTypeFilterDataArray: PropTypes.array,
  onToggleEventTypeFilterMenu: PropTypes.func,
  eventTypeFilterMenuStatus: PropTypes.bool,
};

FilterCollapse.defaultProps = {
  eventTypeFilterDataArray: [],
  onToggleEventTypeFilterMenu: () => {},
  eventTypeFilterMenuStatus: true,
};

const mapStateToProps = createStructuredSelector({
  eventTypeFilterDataArray: makeSelectEventTypeFilterDataArray(),
  eventTypeFilterMenuStatus: makeSelectFilterMenuStatus(),
});

export function mapDispatchToProps(dispatch) {
  return {
    onToggleEventTypeFilterMenu: (value) => dispatch(toggleEventTypeFilterMenu(value)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, memo)(FilterCollapse);
